import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/core/api.service';
import { ActivityLogItemService } from '../activity-log-item.service';
import { ListItem } from '@material-library';
import { EVENT_LIMIT, EventPathitems } from '../activity-log.model';
import { User } from 'src/app/shared/models';
import { Router } from '@angular/router';

@Component({
  selector: 'app-activity-log-detail',
  templateUrl: './activity-log-detail.component.html',
  styleUrls: ['./activity-log-detail.component.scss']
})
export class ActivityLogDetailComponent implements OnInit {
  @Input() public eventId!: string;
  @Input() public onLoad: Function;
  @ViewChild('bottom') bottomRef: ElementRef;

  public isLoading: boolean;
  public pathitems: EventPathitems[] = [];
  public hasMore: boolean;
  public offset = 0;
  public user: User;

  itemList: ListItem[] = [];

  constructor(
    private apiService: ApiService,
    private activityLogItemService: ActivityLogItemService,
    private router: Router,
  ) { }


  ngOnInit() {
    this.getList();
  }

  async getList() {
    const opts = {
      _id: this.eventId,
      slice_offset: this.offset
    };
    this.isLoading = true;
    try {
      const apiResult: any = await this.apiService.execute('eventslist', opts);
      const eventList = await this.processEventList(apiResult.events);
      apiResult.events = eventList;
      this.hasMore = apiResult.events[0].items.pathitems.length === EVENT_LIMIT;
      this.pathitems = [...this.pathitems, ...apiResult.events[0].items.pathitems];
      this.onLoad(this.pathitems);
      this.setEventListItemParams();

    } catch (err) {
    } finally {
      this.isLoading = false;
    }
  }

  async onLoadMore() {
    this.offset += EVENT_LIMIT;
    await this.getList();
    setTimeout(() => {
      this.bottomRef.nativeElement.scrollIntoView();
    });
  }

  public trackbyFunction(index) {
    return index;
  }

  private async processEventList(events: any[]) {
    const eventItems: Promise<any>[] = [];
    for (let i = 0, len = events.length; i < len; i++) {
      eventItems.push(this.activityLogItemService.format(events[i]));
    }
    return await Promise.all(eventItems);
  }

  private setEventListItemParams() {
    this.itemList = this.pathitems.map((item) => {
      const routerLink = this.activityLogItemService.itemLink(item);
      const routerParams = this.activityLogItemService.getStateParams(item);
      return {
        primaryText: item.name,
        secondaryText: item.file_size.toString(),
        isSelected: false,
        divider: true,
        isInteractive: true,
        leadAdornmentConfig: { enabled: true, type: 'list-head', size: 'large', iconName: this.getIconName(item) },
        trail1AdornmentConfig: { enabled: true, type: 'chip', size: 'large', chipConfig: { label: this.getChipLabel(item), size: 'large', } },
        trail2AdornmentConfig: { enabled: true, type: 'icon', size: 'large', iconName: 'chevron-right' },
        onClick: () => {
          this.router.navigate([routerLink], {queryParams: routerParams});
        },
        wrap: true
      }
    });
  }
  private isFile(item: any) {
    return item.synctype.indexOf('stDIR') == -1;
  }

  private getIconName(item): string {

    let icon = 'folder';
    // 'images/icons/' + (this.isFile(item) ? 'file' : 'folder')
    icon = (this.isFile(item) ? 'file' : 'folder')
    return icon
  }

  private getChipLabel(item): string {
    let label = 'folder';
    if (item.active > 0) {
      label = 'Added';
    }
    if (item.active < 0) {
      label = 'Removed';
    }
    return label
  }
}

export function isFile(item: any): boolean {
  return item.synctype.indexOf('stDIR') === -1;
}